import { takeLatest, put, select, take, race, call } from 'redux-saga/effects';

import { createStandaloneToast, theme } from '@frontend/components';

import { componentUpdatePending } from 'modules/quotes/quoteItems/data/actions';

import { supplierMaterialsService } from 'services/materialService';

import { receiveSupplierMaterialFromGetOrCreate } from 'store/materials/actions';
import { getMaterialById } from 'store/materials/reducer';
import { getGroupId } from 'store/session/selectors';

import { getErrorMessage } from 'utils/stringUtils';

import {
  updateSupplierMaterial,
  updateLocalSupplierMaterial,
  materialModal,
  types,
} from './actions';

const toast = createStandaloneToast({ theme: theme });

export default function* root() {
  yield takeLatest(
    types.UPDATE_QPV_SUPPLIER_MATERIAL_REQUEST,
    watchUpdateSupplierMaterial,
  );
  yield takeLatest(
    types.QPV_MATERIAL_MODAL_SAVE_REQUEST,
    watchMaterialModalSave,
  );
}

function* watchMaterialModalSave(action) {
  const {
    materialId,
    data,
    supplierMaterial: localSupplierMaterial,
  } = action.payload;
  const groupId = yield select(getGroupId);
  try {
    let response;
    if (localSupplierMaterial) {
      response = yield call(
        supplierMaterialsService.update,
        localSupplierMaterial.id,
        data,
      );
    } else {
      response = yield call(
        supplierMaterialsService.create,
        groupId,
        materialId,
        data,
      );
    }
    yield put(
      materialModal.save.success({
        supplierMaterial: response,
      }),
    );
    yield put(
      receiveSupplierMaterialFromGetOrCreate({ supplierMaterial: response }),
    );
  } catch (error) {
    yield call(console.error, error);
    yield put(materialModal.save.error());
    yield call(toast, {
      title: localSupplierMaterial
        ? 'Failed to Update Material'
        : 'Failed to Create Material',
      status: 'error',
      description: getErrorMessage(error),
    });
  }
}

function* watchUpdateSupplierMaterial(action) {
  const { materialId, supplierMaterial } = action.payload;
  try {
    const material = yield select(getMaterialById, materialId);
    yield put(materialModal.open({ material, supplierMaterial }));
    const winner = yield race({
      success: take(types.QPV_MATERIAL_MODAL_SAVE_SUCCESS),
      error: take(types.QPV_MATERIAL_MODAL_CLOSE),
    });

    if (winner.success) {
      yield put(componentUpdatePending.start());

      const { supplierMaterial } = winner.success.payload;
      yield put(receiveSupplierMaterialFromGetOrCreate({ supplierMaterial }));
      yield put(updateLocalSupplierMaterial({ supplierMaterial }));
      yield put(updateSupplierMaterial.success());
    }
  } catch (error) {
    console.error(error);
    yield put(updateSupplierMaterial.error());
  } finally {
    yield put(componentUpdatePending.finish());
  }
}
